export default __webpack_public_path__ + "51fbc7a62a99a6c1eef709c00827d25a.png";